<template>
  <div>
    <div class="d-flex align-center mb-4">
      <div>
        <div class="text-h6">Campanhas</div>
        <div class="text-caption text--secondary">
          {{
            scope === "ultimate"
              ? "Disparos pela conta padrão do sistema"
              : "Disparos pela conta desta empresa"
          }}
        </div>
      </div>
      <v-spacer />
      <v-btn color="primary" :disabled="!canCreate" @click="openCreate">
        <v-icon left>mdi-plus</v-icon>
        Nova campanha
      </v-btn>
    </div>

    <v-alert v-if="error" type="error" text dense class="mb-4">{{ error }}</v-alert>
    <v-alert v-if="setup && !canCreate" type="warning" text dense class="mb-4">
      Não há conta de WhatsApp ou e-mail neste escopo. Cadastre uma conta antes de criar a campanha.
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="campaigns"
      :loading="loading"
      item-key="id"
      no-data-text="Nenhuma campanha"
      @click:row="open"
    >
      <template v-slot:item.name="{ item }">
        <router-link :to="detailRoute(item.id)">{{ item.name }}</router-link>
      </template>
      <template v-slot:item.channel="{ item }">
        {{ item.channel === "EMAIL" ? "E-mail" : "WhatsApp" }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ campaignStatusLabel[item.status] || item.status }}
      </template>
      <template v-slot:item.templateStatus="{ item }">
        {{ templateStatusLabel[item.templateStatus] || item.templateStatus }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ formatDate(item.updatedAt) }}
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="480">
      <v-card>
        <v-card-title>Nova campanha</v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name" label="Nome" outlined dense />
          <v-select
            v-model="form.channel"
            :items="channelOptions"
            label="Canal"
            outlined
            dense
          />
          <v-alert v-if="createError" type="error" text dense>{{ createError }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="creating" @click="create">Criar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  campaignApi,
  campaignStatusLabel,
  templateStatusLabel,
} from "@/services/admin/campaigns";

export default {
  props: {
    scope: { type: String, required: true },
  },
  data: () => ({
    campaignStatusLabel,
    templateStatusLabel,
    campaigns: [],
    setup: null,
    loading: false,
    error: "",
    dialog: false,
    creating: false,
    createError: "",
    form: { name: "", channel: "WHATSAPP" },
    headers: [
      { text: "Nome", value: "name" },
      { text: "Canal", value: "channel" },
      { text: "Status", value: "status" },
      { text: "Template", value: "templateStatus" },
      { text: "Eventos", value: "eventCount" },
      { text: "Atualizada", value: "updatedAt" },
    ],
  }),
  computed: {
    api() {
      return campaignApi(this.scope);
    },
    canCreate() {
      if (!this.setup) return false;
      return this.setup.channels.WHATSAPP || this.setup.channels.EMAIL;
    },
    channelOptions() {
      const options = [];
      if (!this.setup || this.setup.channels.WHATSAPP) {
        options.push({ text: "WhatsApp", value: "WHATSAPP" });
      }
      if (!this.setup || this.setup.channels.EMAIL) {
        options.push({ text: "E-mail", value: "EMAIL" });
      }
      return options;
    },
  },
  created() {
    this.load();
  },
  methods: {
    detailRoute(id) {
      return {
        name: this.scope === "ultimate" ? "ultimate.campaigns.detail" : "admin.campaigns.detail",
        params: { id },
      };
    },
    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleString("pt-BR");
    },
    async load() {
      this.loading = true;
      this.error = "";
      try {
        const [list, setup] = await Promise.all([this.api.list(), this.api.setup()]);
        this.campaigns = list.campaigns || [];
        this.setup = setup;
      } catch (error) {
        this.error = error.message || "Não foi possível carregar as campanhas";
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      const channel = this.setup?.channels.WHATSAPP
        ? "WHATSAPP"
        : "EMAIL";
      this.form = { name: "", channel };
      this.createError = "";
      this.dialog = true;
    },
    open(item) {
      this.$router.push(this.detailRoute(item.id));
    },
    async create() {
      this.creating = true;
      this.createError = "";
      try {
        const campaign = await this.api.create({
          name: this.form.name,
          channel: this.form.channel,
          partyIds: [],
        });
        this.dialog = false;
        this.$router.push(this.detailRoute(campaign.id));
      } catch (error) {
        this.createError = error.message || "Não foi possível criar a campanha";
      } finally {
        this.creating = false;
      }
    },
  },
};
</script>
